import { render, staticRenderFns } from "./ConfirmCode.vue?vue&type=template&id=5fbac2cb&scoped=true&"
import script from "./ConfirmCode.vue?vue&type=script&lang=js&"
export * from "./ConfirmCode.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmCode.vue?vue&type=style&index=0&id=5fbac2cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbac2cb",
  null
  
)

export default component.exports